import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    const m = loc.hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    done.current = true;
    googleLogin(decodeURIComponent(m[1]))
      .then((u) => { toast.success(`Welcome${u.name ? ", " + u.name.split(" ")[0] : ""}!`); nav(u.role === "admin" ? "/admin" : "/dashboard", { replace: true }); })
      .catch((e) => { toast.error(errMsg(e)); nav("/login", { replace: true }); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div className="min-h-[70vh] grid place-items-center text-slate-500" data-testid="auth-callback">Signing you in…</div>;
}
